// Module
var code = `<ul>
  <li>
    <header>
<!--
      <p class="h5">{{content.0.elementName}}</p>
-->
      <p class="el-tags"><b>{{content.0.elementName}}</b>: {{content.0.elementTags}}</p>
      <p class="attributes">
        {{#content.0.attributes}}
        <span>{{.*}}</span>

        {{/content.0.attributes}}
      </p>
    </header>
  </li>
  <li>
    <header>
<!--
      <p class="h5">{{content.1.elementName}}</p>
-->
      <p class="el-tags"><b>{{content.1.elementName}}</b>: {{content.1.elementTags}}</p>
      <p class="attributes">
        {{#content.1.attributes}}
        <span>{{.*}}</span>

        {{/content.1.attributes}}
      </p>
    </header>
  </li>
  <li>
    <header>
<!--
      <p class="h5">{{content.2.elementName}}</p>
-->
      <p class="el-tags"><b>{{content.2.elementName}}</b>: {{content.2.elementTags}}</p>
      <p class="attributes">
        {{#content.2.attributes}}
        <span>{{.*}}</span>

        {{/content.2.attributes}}
      </p>
    </header>
  </li>
  <li>
    <header>
<!--
      <p class="h5">{{content.3.elementName}}</p>
-->
      <p class="el-tags"><b>{{content.3.elementName}}</b>: {{content.3.elementTags}}</p>
      <p class="attributes">
        {{#content.3.attributes}}
        <span>{{.*}}</span>

        {{/content.3.attributes}}
      </p>
    </header>
  </li>
  <li>
    <header>
<!--
      <p class="h5">{{content.4.elementName}}</p>
-->
      <p class="el-tags"><b>{{content.4.elementName}}</b>: {{content.4.elementTags}}</p>
      <p class="attributes">
        {{#content.4.attributes}}
        <span>{{.*}}</span>

        {{/content.4.attributes}}
      </p>
    </header>
  </li>
  <li>
    <header>
<!--
      <p class="h5">{{content.5.elementName}}</p>
-->
      <p class="el-tags"><b>{{content.5.elementName}}</b>: {{content.5.elementTags}}</p>
      <p class="attributes">
        {{#content.5.attributes}}
        <span>{{.*}}</span>

        {{/content.5.attributes}}
      </p>
    </header>
  </li>
  <li>
    <header>
<!--
      <p class="h5">{{content.6.elementName}}</p>
-->
      <p class="el-tags"><b>{{content.6.elementName}}</b>: {{content.6.elementTags}}</p>
      <p class="attributes">
        {{#content.6.attributes}}
        <span>{{.*}}</span>

        {{/content.6.attributes}}
      </p>
    </header>
  </li>
  <li>
    <header>
<!--
      <p class="h5">{{content.7.elementName}}</p>
-->
      <p class="el-tags"<b>{{content.7.elementName}}</b>: {{content.7.elementTags}}</p>
      <p class="attributes">
        {{#content.7.attributes}}
        <span>{{.*}}</span>

        {{/content.7.attributes}}
      </p>
    </header>
  </li>
  <li>
    <header>
<!--
      <p class="h5">{{content.8.elementName}}</p>
-->
      <p class="el-tags"><b>{{content.8.elementName}}</b>: {{content.8.elementTags}}</p>
      <p class="attributes">
        {{#content.8.attributes}}
        <span>{{.*}}</span>

        {{/content.8.attributes}}
      </p>
    </header>
  </li>
</ul>
`;
// Exports
module.exports = code;